module.exports = __webpack_public_path__ + "img/GrayCheckmark.429c4d09.svg";